window.addEventListener('DOMContentLoaded',(e)=>{
    const kv = document.getElementById('js-indexKv-swiper');

    // --- 動画が1つでもあるか判定 ---
    const hasVideo = kv.querySelector('.indexKv__in__slide__video') !== null;

    const index_visual_slider = new Swiper('#js-indexKv-swiper', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        speed: 1800,

        autoplay: hasVideo ? false : {
            delay: 7000,
            disableOnInteraction: false
        },

        pagination: {
            el: '.js-indexKv__in__pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.js-indexKv__in__next',
            prevEl: '.js-indexKv__in__prev',
        },
    });

  const bodyTag = document.getElementsByTagName("body")[0];
  const indexKv = document.getElementById("js-indexKv-swiper");
  let indexKv_1_6_height = indexKv.offsetHeight / 6;
  window.addEventListener('scroll',function(){
    const scrollTop = document.documentElement.scrollTop;
    if (scrollTop > indexKv_1_6_height) {
      indexKv.classList.add('js-indexKv__in--scrolled');

      if(document.querySelector(".js-body-scrolled--comeBack") != null) {
        bodyTag.classList.remove('js-body-scrolled--comeBack');
      }

    } else if (scrollTop < indexKv_1_6_height) {
      if(document.querySelector(".js-body-scrolled--comeBack") != null) {
        indexKv.classList.remove('js-indexKv__in--scrolled');
      }
    }
  });
  //NEW ARRIVALS--------------------------------------------------------------------------------------------------------
  if (document.getElementById("js-indexNewArv__cont__in--left") != null) {
    const indexNewArv_swiper_right = new Swiper('#js-indexNewArv__cont__in--right', {
      allowTouchMove: false, // 手動でのスワイプを禁止
      speed: 500,
    });
    const indexNewArv_swiper_left = new Swiper('#js-indexNewArv__cont__in--left', {
      speed: 500,
      thumbs: {
        swiper: indexNewArv_swiper_right,
      },
      navigation: {
        prevEl: '.indexNewArv__cont__in__wrap__navi--prev',
        nextEl: '.indexNewArv__cont__in__wrap__navi--next',
      },
      breakpoints: {
        1024: {
          allowTouchMove: false, // 手動でのスワイプを禁止
        }
      }
    });
    // 読み込み時にデフォルトで選択した画像からバリエーションIDを取得してhrefを書き換える
    // すべてのスライド要素を取得
    const newArv_left_slideAll = document.querySelectorAll('#js-indexNewArv__cont__in--left .js-indexNewArv__cont__in__wrap__slide');
    newArv_left_slideAll.forEach(newArv_left_slide => {
      // スライド内の画像要素を取得
      const productImages = newArv_left_slide.querySelectorAll('.js-product-card-image');
      productImages.forEach(productImage => {
        const dataSrc = productImage.getAttribute('data-src');
        if (dataSrc) {
          // data-src属性からバリエーションIDを抽出
          const variantIdMatch = dataSrc.match(/transparent-(\d+)\.png/);
          if (variantIdMatch) {
            const variantId = variantIdMatch[1];
            // スライド内のリンク要素を取得してhrefを更新
            const productLink = newArv_left_slide.querySelector('.c-product-card__link');
            if (productLink) {
              let url = new URL(productLink.href);
              if (!url.searchParams.has('variant')) {
                url.searchParams.set('variant', variantId);
                productLink.href = url.toString();
              }
            }
            // スライド内のボタン要素を取得してhrefを更新
            const productButton = newArv_left_slide.querySelector('.js-indexNewArv__cont__in__wrap__slide__btn');
            if (productButton) {
              let url = new URL(productButton.href);
              if (!url.searchParams.has('variant')) {
                url.searchParams.set('variant', variantId);
                productButton.href = url.toString();
              }
            }
            // 初期価格を設定
            const priceElement = newArv_left_slide.querySelector('.js-product-price');
            const colorChips = newArv_left_slide.querySelectorAll('.js-c-btn-colorChip');
            if (priceElement && colorChips.length > 0) {
              const defaultChip = Array.from(colorChips).find(chip => chip.getAttribute('data-url').includes(variantId));
              if (defaultChip) {
                const variantPriceFormatted = defaultChip.getAttribute('data-price-formatted');
                if (variantPriceFormatted) {
                  priceElement.innerHTML = `${variantPriceFormatted}<small>（税込）</small>`;
                }
              }
            }
          }
        }
      });
    });
    // カラーチップのクリックにより「商品を見る」ボタンのurlを変更する
    const newArv_colorChips = document.querySelectorAll('#js-indexNewArv__cont__in--left .js-c-btn-colorChip');
    newArv_colorChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        const newUrl = chip.getAttribute('data-url');
        const parentSlide = chip.closest('.js-indexNewArv__cont__in__wrap__slide');
        const targetButton = parentSlide.querySelector('.js-indexNewArv__cont__in__wrap__slide__btn');
        if (targetButton) {
          targetButton.setAttribute('href', newUrl);
        }
        // 右側のスライドのhrefも更新
        // const rightSlides = document.querySelectorAll('#js-indexNewArv__cont__in--right .js-indexNewArv__cont__in__wrap__slide--right');
        // rightSlides.forEach(function (rightSlide) {
        //   rightSlide.setAttribute('href', newUrl);
        // });
        // カラーチップのクリックにより価格を更新する
        const el_target_price = parentSlide.querySelector('.js-product-price');
        const variant_price_formatted = chip.getAttribute('data-price-formatted');
        if (el_target_price && variant_price_formatted) {
          el_target_price.innerHTML = `${variant_price_formatted}<small>（税込）</small>`;
        }
      });
    });
  }
  //Instagramセクションの末尾にボタンを追加-----------------------------------------------------------------------------------
  if(document.querySelector(".socialphotos-com-gallery") != null) {
    const instagramElm = document.querySelector(".socialphotos-com-gallery").parentElement;
    //ボタン要素を作成
    const newLink = document.createElement('a');
    newLink.classList.add('c-btn', 'c-btn--black', 'js-indexInstagramBtn');
    newLink.href = '/blogs/sns'; // href属性を設定
    newLink.textContent = 'すべてのInstagramを見る';
    //末尾に移動
    instagramElm.appendChild(newLink);
  }
})
window.addEventListener('load',(e)=>{
  document.getElementById("js-indexKv-swiper").classList.add("js-indexKv-swiper--loaded");
});